const appError = [{
	//App 錯誤追蹤（僅總會，權限群組 22）
	path: "app/errors",
	name: "AdminAppError",
	meta: {
		permission: 22001,
		breadcrumb: [{
			key: 'admin.appError.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/app/error/index.vue"),
}, {
	//App 錯誤追蹤 - 錯誤內容
	path: "app/errors/edit/:uuid",
	name: "AdminAppErrorEdit",
	meta: {
		permission: 22004,
		breadcrumb: [{
			key: 'admin.appError.index',
			value: "AdminAppError"
		}, {
			key: 'admin.appError.edit',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/app/error/edit.vue"),
}];

export default appError;
